import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { testIds } from "@/constants/testIds";
import { toast } from "sonner";
import { LogIn, UserPlus } from "lucide-react";

export default function CollabLogin() {
  const { loginCollab } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await loginCollab(email, pw);
      toast.success("Accesso effettuato");
      nav("/collaboratori");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-10">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-zinc-900/90 border border-zinc-800 rounded-2xl p-6 sm:p-8 shadow-2xl"
      >
        <div className="w-12 h-12 rounded-xl bg-rose-600/15 border border-rose-500/30 flex items-center justify-center mb-4 mx-auto">
          <LogIn className="text-rose-500" size={20} />
        </div>
        <h1 className="font-heading text-2xl font-black uppercase text-center text-white">
          Area Service
        </h1>
        <p className="text-center text-xs text-zinc-500 mt-1 mb-6 font-mono uppercase tracking-widest">
          Accesso collaboratori Spectrum
        </p>

        <label className="block text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-1.5">
          Email
        </label>
        <input
          data-testid={testIds.collabLoginEmail}
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="tuo@service.it"
          className="w-full min-h-[48px] px-4 rounded-lg bg-zinc-950 border border-zinc-800 focus:border-rose-600 focus:outline-none focus:ring-2 focus:ring-rose-600/20 text-white placeholder-zinc-700 text-sm mb-3"
        />
        <label className="block text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-1.5">
          Password
        </label>
        <input
          data-testid={testIds.collabLoginPassword}
          type="password"
          required
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          className="w-full min-h-[48px] px-4 rounded-lg bg-zinc-950 border border-zinc-800 focus:border-rose-600 focus:outline-none focus:ring-2 focus:ring-rose-600/20 text-white text-sm mb-4"
        />
        <button
          data-testid={testIds.collabLoginBtn}
          type="submit"
          disabled={loading || !email || !pw}
          className="w-full min-h-[48px] rounded-lg bg-rose-600 hover:bg-rose-500 disabled:opacity-50 text-white font-heading font-black uppercase tracking-wider text-sm shadow-lg shadow-rose-900/40 transition active:scale-[0.98] flex items-center justify-center gap-2"
        >
          <LogIn size={16} />
          {loading ? "Accesso..." : "Entra"}
        </button>

        <div className="mt-6 pt-6 border-t border-zinc-800 text-center">
          <div className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 mb-2">
            Non hai un account?
          </div>
          <Link
            to="/collaboratori/registrati"
            className="inline-flex items-center gap-2 text-rose-400 hover:text-rose-300 text-sm font-semibold transition"
          >
            <UserPlus size={14} /> Registra il tuo service
          </Link>
        </div>
      </form>
    </div>
  );
}
